import React from "react";
import padStart from "lodash/padStart";
import PropTypes from "prop-types";
import Image from "../global/Image";
import SmartColour from "../../utils/ColourHandler";
import SmartWidth from "../../utils/ImageWidthHandler";
import CTAs from "../global/Ctas";

/********************************
<Card />
/********************************
Version: 1
Created: 13 08 2023
Updated: 23 01 2025
Author: Richy Pears
/********************************
Returns a multi-use card mainly
for use in the <Columns />
component
/********************************/

const Card = ({ columns, node, number, theme }) => {
  if (!node) return null; // Escape hatch

  const colour = SmartColour(theme);

  const imageWidth = SmartWidth(columns && columns, "width"); // This returns optimum widths for our images

  return (
    <div
      className={`p-3 h-full w-full
        ${
          columns?.xs && columns?.xs !== "auto"
            ? ` w-1/${columns.xs} shrink-0`
            : ` shrink`
        }
        ${
          columns?.sm && columns?.sm !== "auto"
            ? ` sm:w-1/${columns.sm} sm:shrink-0`
            : ` sm:shrink`
        }
        ${
          columns?.md && columns?.md !== "auto"
            ? ` md:w-1/${columns.md} md:shrink-0`
            : ` md:w-full md:shrink`
        }
        ${
          columns?.lg && columns?.lg !== "auto"
            ? ` lg:w-1/${columns.lg} lg:shrink-0`
            : ` lg:w-full lg:shrink`
        }
        ${
          columns?.xl && columns?.xl !== "auto"
            ? ` xl:w-1/${columns.xl} xl:shrink-0`
            : ` xl:w-full xl:shrink`
        }
      `}
    >
      <div
        className={`flex flex-col w-full h-full rounded-3xl relative ${
          colour.classes && colour.classes
        }`}
      >
        {number && (
          <span className="pt-6 pl-6 absolute top-0 left-0 text-base font-medium tracking-[4px] uppercase m-0">
            {padStart(number, 3, "0")}
          </span>
        )}

        {node.image && (
          <div
            className={`flex flex-col justify-center itens-center bg-gradient-radial from-${
              node.glow ? node.glow : "white"
            }/40 from-0% to-transparent to-70% ${
              node.image_size === "icon" ? "aspect-1x1" : "aspect-3x2"
            }`}
          >
            <Image
              aspect={node.image_size === "icon" ? "1x1" : null}
              className={
                node.image_size === "icon"
                  ? "w-1/3 m-auto"
                  : "w-full max-w-full"
              }
              sizes={imageWidth}
              src={node.image}
            />
          </div>
        )}
        <div
          className={`flex flex-col gap-5 p-5 text-center ${
            node.image_size === "icon" ? "-mt-12" : null
          }`}
        >
          <span
            className={`w-10 h-[4px] bg-${colour.text} rounded-full m-auto`}
          />
          {node.title && <h2 className="m-0">{node.title}</h2>}
          {node.subtitle && <h3 className="m-0">{node.subtitle}</h3>}
          {node.copy && <p className="m-0 text-lg">{node.copy}</p>}
          {node.ctas && (
            <CTAs
              ctas={node.ctas}
              layout="column"
              align="center"
              className="mt-3"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;

Card.defaultProps = {
  columns: null,
  node: null,
};

Card.propTypes = {
  columns: PropTypes.object,
  node: PropTypes.object,
};
